module.exports = __webpack_public_path__ + "img/thumb_03.93200312.jpg";